import Quill from 'quill';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BlockEmbed: any = Quill.import('blots/block/embed');

export class DividerBlot extends BlockEmbed {
  static blotName = 'divider';
  static tagName = 'HR';
  static className = 'ql-divider';

  static create(): HTMLElement {
    const node = super.create() as HTMLElement;
    node.setAttribute('contenteditable', 'false');
    return node;
  }
}
